import React from 'react';
import { connect } from 'react-redux';
import Sensor from './sensor';
import Area from './area';
import config from 'config';
import DeviceSetting from "./devicesetting";
import { fetchImage } from 'actions/floorplan';
import { getSensorAverage, getParams } from 'actions/stats';
import { selectViewFilter } from "actions/live/filter";
import { SelectableGroup } from 'react-selectable-fast-forked';
import Modal from "components/common/modal";
export class FloorPlan extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            loading: false,
            hasPermission: this.hasPermission(),
            url: "",
            selectedSensors: [],
            selectingMode: "view" // selecting, selected, view
        };
        this.selectableGroup = React.createRef();
    }
    // default view filter is Configuration View
    componentDidMount() {
        this.props.dispatch(selectViewFilter(config.viewFilter[3]));
    }

    getImage(urlList, node) {
        while (node) {
            if (node.info.useownfp) {
                return urlList[node.id.toString()];
            }
            node = node.parent;
        }
        // return undefined
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ hasPermission: this.hasPermission(nextProps) })
        if (this.state.loading) {
            var url = this.getImage(nextProps.images, nextProps.root)
            if (url != this.state.url) {
                this.setState({ url: url, loading: false });
            }
        }
    }
    fetchSensorAvg(props) {
        var params = getParams({
            querySettings: props.query,
            currentNode: props.root
        })
        this.props.dispatch(getSensorAverage(params, props.root))
        this.setState({
            isFetched: !this.state.isFetched
        })
    }
    querySettingsChanged(q1, q2) {
        return (
            q1.startdate !== q2.startdate ||
            q1.enddate !== q2.enddate ||
            q1.starthour !== q2.starthour ||
            q1.endhour !== q2.endhour ||
            q1.weekdaymask !== q2.weekdaymask
        );
    }
    imageError() {
        this.setState({
            loading: true
        })
        this.props.dispatch(fetchImage(this.props.user.companyid))
    }

    // Multiple selection feature
    duringSelection() {
        this.setState({
            selectingMode: "selecting"
        })
    }

    onSelectionFinish(selectedItems) {
        // set selectedSensors
        let selectedSensors = []
        selectedItems.map(sensor => {
            selectedSensors.push({
                sensorId: sensor.props.selectableSensors.sensorId,
                sensorMac: sensor.props.selectableSensors.macaddress
            })
        })
        this.setState({
            selectedSensors: selectedSensors
        }, () => console.log("current selected Sensors at timestamp", Date.now(), this.state.selectedSensors))
    }

    handleRightClick(e) {

        let devicemanagementPage = window.location.href.split('#')[1].match(/\/devicemanagement\/\w+/ig)
        if (devicemanagementPage) {
            e.preventDefault(); e.stopPropagation()
            this.onSelectionClear();
            console.log('Cancel selection')
            this.selectableGroup.current.clearSelection();
        }
    }
    onSelectionClear() {
        this.setState({
            selectingMode: "view",
            selectedSensors: []
        })
    }
    render() {
        if (!this.props.root || !this.props.configMap) {
            return null;
        }
        var areas = [], sensors = [];
        this.listNodes(this.props.root, areas, sensors)

        if (!this.state.loading && !this.props.root.info.empty) {
            var url = this.getImage(this.props.images, this.props.root)

            if (url && this.props.root.info.hasfloorplan) {
                return (
                    <div className="row no-pad row-eq-height">
                        <div className={`${!this.props.thumbnail ? 'col-lg-7' : 'col-lg-12'} justify-center`}>
                            <div className={"floorplan-outer-container " + (!this.props.thumbnail ? "not-thumbnail_device-managment" : "")}>
                                {
                                    (!this.props.thumbnail) &&
                                    <div className="floorplan-options-container">
                                        <div className="floorplan-options">
                                            <div className="options-help">
                                                <React.Fragment>
                                                    <div className="help-icon ">
                                                        <Modal
                                                            disableCloseButton={true}
                                                            ref={(elem) => { this.openInfoModal = elem }}
                                                            clickButton={() => { this.openInfoModal.close(); }}
                                                            header="Multiple sensors selection"
                                                            buttonText="Got it"
                                                            buttonClass="btn-success"
                                                            entry={
                                                                <img onClick={() => { this.openInfoModal.open() }} className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
                                                            }
                                                            className="help-icon_modal"
                                                        >
                                                            <p>Click on the sensor one by one</p>
                                                            <p>Alternatively, left click and drag the cursor around the sensors</p>
                                                            <p>Right click to cancel configuration</p>
                                                            <p>All sensors with same configuration have the same color. If the sensor configuration is being updated (there is a difference between ‘read value’ and ‘sent value’), the sensor will blink.</p>
                                                        </Modal>


                                                    </div>
                                                    <div className={(this.props.viewFilter.code !== "CONFIGURATION") ? "help-text ht-show" : "help-text ht-hide"}>Hover over a sensor for more info.</div>

                                                    {this.props.viewFilter.code === "CONFIGURATION" &&
                                                        <React.Fragment>
                                                            <div className={this.state.selectingMode === "view" || this.state.selectedSensors.length === 0 ? "help-text ht-show" : "help-text ht-hide"}>Left click & drag the cursor around to select multiple sensors</div>
                                                            {this.state.selectedSensors.length > 0 &&
                                                                <div className={this.state.selectingMode === "selecting" || this.state.selectingMode === "selected" ? "help-text ht-show" : "help-text ht-hide"}>Right click or Press ESC to cancel</div>
                                                            }
                                                        </React.Fragment>
                                                    }
                                                </React.Fragment>
                                            </div>
                                            <div className="options-buttons-container">
                                                <div className="options-buttons-wrapper">
                                                    {this.props.children}
                                                    <div className="options-buttons">
                                                        <i
                                                            className="material-icons"
                                                            data-tooltip={(this.props.showDetails) ? "Showing details" : "Hiding details"}
                                                            onClick={() => this.props.changeMRMode()}
                                                        >
                                                            {(this.props.showDetails) ? "settings_ethernet" : "code"}
                                                        </i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="floorplan--divider" />
                                    </div>
                                }
                                <div
                                    ref={(e) => { this.floorplan = e }} className={`device-management-floorplan ${!this.props.thumbnail ? "floorplan-container" : "floorplan-container-thumbnail"}`}>
                                    <div
                                        onContextMenu={this.handleRightClick.bind(this)}
                                        style={{ position: "relative", width: "100%", height: "100%" }}>

                                        <SelectableGroup
                                            selectboxClassName="selectbox-device"
                                            ref={this.selectableGroup}
                                            mixedDeselect={true}
                                            enableDeselect={true}
                                            tolerance={0}
                                            deselectOnEsc={true}
                                            allowClickWithoutSelected={true}
                                            duringSelection={this.duringSelection.bind(this)}
                                            onSelectionClear={this.onSelectionClear.bind(this)}
                                            onSelectionFinish={this.onSelectionFinish.bind(this)}
                                            ignoreList={['.not-selectable']}
                                        // disabled={this.props.viewFilter.code === "CONFIGURATION" ? false : true}
                                        >
                                            <React.Fragment>
                                                <img
                                                    src={url}
                                                    alt="Floorplan"
                                                    className="floorplan-image .not-selectable"
                                                    ref="floorplan-image"
                                                    onError={this.imageError.bind(this)}
                                                    draggable="false"
                                                    key="image"
                                                />
                                                {sensors.map((sensor) => {
                                                    var ss = this.props.sensorMap.get(sensor.id);
                                                    // defined this var to later access on onSelectionFinish()
                                                    let selectableSensors = { sensorId: sensor.id, macaddress: sensor.info.details.macaddress }
                                                    return (ss &&
                                                        <Sensor
                                                            selectableSensors={selectableSensors}
                                                            key={sensor.id}
                                                            selectingMode={this.state.selectingMode}
                                                            sensor={ss}
                                                            viewFilter={this.props.viewFilter}
                                                            thumbnail={this.props.thumbnail}
                                                            color={this.props.colors[ss.macaddress]}
                                                        />
                                                    );
                                                })}
                                                {areas.map((node) => {
                                                    return (
                                                        <Area
                                                            viewFilter={this.props.viewFilter}
                                                            key={node.id}
                                                            node={node}
                                                            thumbnail={this.props.thumbnail}
                                                        />
                                                    );
                                                })}
                                            </React.Fragment>

                                        </SelectableGroup>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            !this.props.thumbnail &&
                            <div className="col-lg-5 justify-center" style={{ paddingLeft: "20px" }}>
                                <DeviceSetting
                                    isClicked={this.state.selectedSensors.length > 0}
                                    selectedSensors={this.state.selectedSensors}
                                />
                            </div>
                        }
                    </div >
                );
            } else {
                return <div className="floorplan-error">
                    <br />
                    <h2>Oops ! We can't find this location's floorplan...</h2>
                </div>
            }
        } else {
            return <div className="floorplan-error">
                <br />
                <h2>Loading...</h2>
            </div>
        }
    }
    hasPermission(Props) {
        var props = Props || this.props;
        var node = props.root;
        if (props.user.role != "ADMIN" && props.user.role != "SUPPORTUSER") {
            return false;
        }
        while (node) {
            if (node.id == props.user.rootnodeid) {
                return true;
            }
            node = node.parent;
        }
        return false;
    }

    listNodes(root, areas, sensors) {
        var self = this;
        if (root) {
            var isArea = (root.type == "meeting_room" && !this.props.showDetails)
            isArea |= (root.id != this.props.root.id && root.info.useownfp && root.type != "sensor");
            if (isArea) {
                areas.push(root);
            } else {
                if (root.type == "sensor") {
                    sensors.push(root);
                }
                if (root.children) {
                    root.children.forEach((child) => {
                        self.listNodes(child, areas, sensors);
                    });
                }
            }
        }
    }

}

function mapStateToProps(state) {
    return {
        sensorMap: state.nodeReducer.map,
        images: state.floorPlanReducer.images,
        user: state.myAccountReducer.user,
        configMap: state.devManReducer.configMap,
        colors: state.devManReducer.colors
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(FloorPlan);




// WEBPACK FOOTER //
// ./src/components/pages/devicemanagement/floorplan.jsx